module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-03-image-02.6b807b96.png";